import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";

export default function ContactSection() {
  return (
    <section data-testid="contact-section" className="py-12 md:py-16 bg-white">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl text-center">
        <h2
          data-testid="contact-headline"
          className="text-2xl md:text-3xl font-bold text-slate-900"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          Need Help?
        </h2>
        <p className="mt-2 text-slate-600 text-sm md:text-base">
          Any questions or support? Email us — we respond quickly!
        </p>
        <Button
          data-testid="contact-email-btn"
          asChild
          className="mt-6 h-12 px-8 bg-green-700 hover:bg-green-800 text-white rounded-full text-base font-semibold shadow-lg"
        >
          <a href="mailto:teacherutilitytoolkit@gmail.com">
            <Mail className="mr-2 w-5 h-5" />
            teacherutilitytoolkit@gmail.com
          </a>
        </Button>
      </div>
    </section>
  );
}
